<div *ngIf="permissions.length" class="permissions">
    <span class="label" *ngIf="showPeriod">
        {{ getPermission(permissions[0].permission) }}
    </span>
    <div *ngIf="!showPeriod" class="all-permissons-line">
        <span class="label m-r-xs m-b-xs" *ngFor="let p of permissions">
        {{ getPermission(p.permission) }}
    </span>
    </div>

    <button *ngIf="permissions.length > 1 && showPeriod" class="permissions__btn" (click)="toggle()">...</button>

    <div class="permissions__drop-down" [class.active]="isShow" [class.permissions__drop-down_up]="isDirectionTop">
        <span *ngFor="let item of permissions | slice:1" [class]="'label label_' + item.permission">
            {{ getPermission(item.permission) }}
        </span>
    </div>
</div>




// WEBPACK FOOTER //
// /app/src/app/views/documents/document-item/permissions/permissions.component.html